module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "base"
    }
  }, [_c('div', {
    staticClass: "side"
  }, [_c('Sidebar')], 1), _c('div', {
    staticClass: "content-outter"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner-change"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })]), _c('div', {
    staticClass: "dropdown-box",
    class: {
      'active-drop': _vm.show
    },
    on: {
      "mouseenter": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('a', {
    staticClass: "drop-a"
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": require(("../assets/img/icon-big-lang-" + (_vm.$i18n.locale) + ".svg")),
      "alt": "geetest"
    }
  })]), _c('div', {
    staticClass: "dropdown",
    class: {
      'dropdown-show': _vm.show
    }
  }, [_c('div', {
    staticClass: "lang-item",
    on: {
      "click": function($event) {
        return _vm.changeLange('zh')
      }
    }
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": require("../assets/img/icon-big-lang-zh.svg"),
      "alt": "chinese"
    }
  }), _c('span', [_vm._v("简体中文")])]), _c('div', {
    staticClass: "lang-item",
    on: {
      "click": function($event) {
        return _vm.changeLange('en')
      }
    }
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": require("../assets/img/icon-big-lang-en.svg"),
      "alt": "English"
    }
  }), _c('span', [_vm._v("English")])])])])]), _c('router-view')], 1), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "href": _vm.$t('message.terms_link'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.terms')))]), _c('a', {
    attrs: {
      "href": _vm.$t('message.privite_link'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.privite')))]), _vm._v("\n        Copyright © 2012-" + _vm._s(new Date().getFullYear()) + " GeeTest\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36481bd1","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/base.vue
// module id = 654
// module chunks = 2